import { getMatchTier } from '@/utils/matchScore'

interface MatchScoreBadgeProps {
  score: number
  showPercent?: boolean
}

/**
 * Renders a 0-100 score as its tier label (see getMatchTier)
 * instead of a bare percentage — used anywhere a recruiter sees a
 * match/relevance score (Candidate Search v2, AI candidate search, the
 * Applicants AI Score column).
 */
export function MatchScoreBadge({ score, showPercent = true }: MatchScoreBadgeProps) {
  const tier = getMatchTier(score)

  return (
    <span className={`badge ${tier.badgeClass}`.trim()} style={tier.badgeStyle}>
      {tier.label}
      {showPercent ? ` (${score.toFixed(0)}%)` : ''}
    </span>
  )
}
